import React from 'react';

// Presentational only. Selection state lives in ManageAccessPage; the action
// handlers are passed in. In Phase 3 every action is a "Coming soon" stub except
// the close (X); real Revoke wiring lands in Phase 5.
const BulkActionBar = ({
  count, onResend, onRemind, onMove, onRevoke, onClear,
}) => (
  <div className="ma-bulkbar">
    <span className="ma-bulkbar__count">{count} selected</span>
    <div className="ma-bulkbar__actions">
      <button type="button" className="ma-bulkbar__btn" onClick={onResend}>Resend invite</button>
      <button type="button" className="ma-bulkbar__btn" onClick={onRemind}>Remind</button>
      <button type="button" className="ma-bulkbar__btn" onClick={onMove}>Move to walkthrough…</button>
      <button type="button" className="ma-bulkbar__btn ma-bulkbar__btn--danger" onClick={onRevoke}>Revoke access</button>
      <button type="button" className="ma-bulkbar__close" onClick={onClear} aria-label="Clear selection">×</button>
    </div>
  </div>
);

export default BulkActionBar;
